<template>
    <div id="lt-yantr-v2" class="deposit-account-outer container">
        <transition v-if="showLoading" name="fade">
            <div class="loader">
                <img alt="lt-loader" width="61" height="60" src="../../assets/images/offer_images.png" />
            </div>
        </transition>
        <div class="mobile-top-wrap">
            <div v-show="ShowDisclosure" class="ad-disclosure-block">
                <div class="ad-disclosure-inner">
                    <template v-if="ShowHdltgp">
                        <button id="get-paid-btn" class="tooltip-btn a11y-modal-trigger" data-target="get-paid-tooltip">
                            {{ getPaidTitle }}
                        </button>
                        <div class="tooltip-box">
                            <tooltip-view :label="getPaidTitle" :show-on-over="ShowOnOver" :popper-content="getPaidDescription" referenceElement="open me" />
                        </div>
                        <span class="tooltip-divider"> | </span>
                    </template>
                    <button id="ad-disclosure-btn" class="tooltip-btn a11y-modal-trigger" data-target="ad-disclosure-tooltip">
                        {{ adTitle }}
                    </button>
                    <div class="tooltip-box">
                        <tooltip-view :label="adTitle" :show-on-over="ShowOnOver" :popper-content="adTitleDescription" referenceElement="open me" />
                    </div>
                </div>
            </div>
            <div class="form-group data-wrap-select">
                <label>Select account type:</label>
                <select @change="onChange($event)">
                    <option value="savings">Savings Accounts</option>
                    <option value="checking">Checking Accounts</option>
                    <option value="cds">CDs</option>
                </select>
            </div>
        </div>
        <a11y-modal v-if="ShowHdltgp" id="get-paid-tooltip">
            <template #h4> {{ getPaidTitle }} </template>
            <div slot="body">
                <div class="description"> <p> {{ getPaidDescription }} </p></div>
            </div>
        </a11y-modal>
        <a11y-modal id="ad-disclosure-tooltip">
            <template #h4> {{ adTitle }} </template>
            <div slot="body">
                <div class="description"> <p> {{ adTitleDescription }} </p></div>
            </div>
        </a11y-modal>
        <savingComponent v-if="dropdownValue === 'savings'" :viewButtonText="ctaButtonText" :bankHealth="showBankHealth === true ? 'yes' : 'no' " />
        <checkingComponent v-if="dropdownValue === 'checking'" :viewButtonText="ctaButtonText" :bankHealth="showBankHealth === true ? 'yes' : 'no' " />
        <cdComponent v-if="dropdownValue === 'cds'" :viewButtonText="ctaButtonText" :bankHealth="showBankHealth === true ? 'yes' : 'no' " />
    </div>
</template>
<script>
    import savingComponent from './components/deposit-table-saving-data.vue';
    import checkingComponent from './components/deposit-table-checking-data.vue';
    import cdComponent from './components/deposit-table-cd-data.vue';
    import tooltipView from '~/components/tooltip-view.vue';
    import a11yModal from '~/helpers/a11y-modal';
    import A11yModal from '~/components/a11y-modal.vue';

    const currentDate = new Date().toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
    export default {
        props: {
            getPaidTitle: {
                default: 'How Does LendingTree Get Paid?',
            },
            showOnOver: {
                default: true,
            },
            getPaidDescription: {
                default: 'LendingTree is compensated by companies on this site and this compensation may impact how and where offers appears on this site (such as the order). LendingTree does not include all lenders, savings products, or loan options available in the marketplace.',
            },
            adTitle: {
                default: 'Advertising Disclosure',
            },
            adTitleDescription: {
                default: `LendingTree is an advertising-supported deposit account comparison service. LendingTree monitors over 10,000 banks and credit unions. LendingTree does accept advertising compensation for featuring certain products from a very small percentage of these financial institutions. Additionally, the website may earn compensation when a customer clicks on a link, when an application is approved, or when an account is opened. This advertising might influence where these products or financial institutions appear on the site. However, this advertising does not influence whether a product is included on the site, nor does it influence how the products or institutions are assessed within LendingTree’s editorial coverage or its financial health rankings. While very comprehensive, the offers shown below do not include all financial services companies or all of their available product and service offerings. The APYs (Annual Percentage Yields) displayed are as of ${currentDate}.`,
            },
            ctaButtonText: {
                default: 'View Details',
            },
            showBankHealth: {
                default: true,
            },
            hideHdltgp: {
                default: false,
            },
        },
        data() {
            return {
                dropdownValue: 'savings',
                ShowOnOver: this.showOnOver,
                ShowHdltgp: !this.hideHdltgp,
                ShowDisclosure: false,
                showLoading: false,
                showModal: false,
            };
        },
        methods: {
            onChange(event) {
                this.showLoading = true;
                this.dropdownValue = event.target.value;
                setTimeout(() => {
                    this.showLoading = false;
                }, 500);
            },
            setDisclosureShow() {
                setTimeout(() => {
                    this.ShowDisclosure = true;
                }, 500);
            },
            closeA11yModal() {
                a11yModal.closeModal();
            },
            closeModal() {
                this.showModal = false;
            },
        },
        components: {
            savingComponent,
            checkingComponent,
            cdComponent,
            tooltipView,
            A11yModal,
        },
        mounted() {
            setTimeout(() => {
                a11yModal.initModal();
            }, 1000);
        },
    };
</script>
<style src="../../assets/styles/v2/common.scss" lang="scss"></style>
<style src="./main.scss" lang="scss"></style>
<style src="../../assets/styles/a11yModal.scss" lang="scss"></style>
